export const AEVO_RPC_URL = {
  mainnet: "https://rpc-aevo-mainnet-prod-0.t.conduit.xyz/",
  testnet: "https://rpc-aevo-testnet-k1zx5a2ajj.t.conduit.xyz/",
};
